import { GripVertical } from "lucide-react";
import { Group, Panel, Separator } from "react-resizable-panels";
import { cn } from "@/lib/cn";

/**
 * Shadcn-style resizable layout primitives backed by react-resizable-panels v3.
 * v3 renames PanelGroup -> Group and PanelResizeHandle -> Separator. v2's
 * `direction` prop became `orientation`; we accept either for ergonomic parity.
 */
type GroupExtraProps = React.ComponentProps<typeof Group> & {
  direction?: "horizontal" | "vertical";
};

const ResizablePanelGroup = ({
  className,
  direction,
  orientation,
  ...props
}: GroupExtraProps) => (
  <Group
    orientation={orientation ?? direction ?? "horizontal"}
    className={cn("flex h-full w-full data-[orientation=vertical]:flex-col", className)}
    {...props}
  />
);

const ResizablePanel = Panel;

const ResizableHandle = ({
  withHandle,
  className,
  ...props
}: React.ComponentProps<typeof Separator> & { withHandle?: boolean }) => (
  <Separator
    className={cn(
      "relative flex w-1 items-center justify-center bg-border hover:bg-accent transition-colors",
      className,
    )}
    {...props}
  >
    {withHandle && (
      <div className="z-10 flex h-6 w-3 items-center justify-center rounded-sm border bg-border">
        <GripVertical className="h-3 w-3" />
      </div>
    )}
  </Separator>
);

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
